import React, { useRef, useState, useEffect, useCallback } from "react";

const StoryCarousel = ({ paragraphs }) => {
  const trackRef = useRef(null);
  const [index, setIndex] = useState(0);

  const handleScroll = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    const cardWidth = el.clientWidth;
    const i = Math.round(el.scrollLeft / cardWidth);
    setIndex(Math.max(0, Math.min(paragraphs.length - 1, i)));
  }, [paragraphs.length]);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;
    el.addEventListener("scroll", handleScroll, { passive: true });
    return () => el.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const goTo = (i) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollTo({ left: i * el.clientWidth, behavior: "smooth" });
  };

  return (
    <div className="md:hidden" data-testid="story-carousel">
      <div
        ref={trackRef}
        className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide -mx-6"
      >
        {paragraphs.map((p, i) => (
          <div
            key={i}
            className="w-full flex-shrink-0 snap-center px-6"
            data-testid={`story-card-${i}`}
          >
            <div className="bg-[var(--ivory)] border border-[var(--border-soft)] p-7 min-h-[240px] flex items-center">
              <p className="text-[var(--text-secondary)] leading-[1.8] text-[15px] font-light">
                {p}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-center gap-2 mt-6" data-testid="story-dots">
        {paragraphs.map((_, i) => (
          <button
            key={i}
            type="button"
            onClick={() => goTo(i)}
            aria-label={`Go to story card ${i + 1}`}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              i === index
                ? "w-8 bg-[var(--sage-deep)]"
                : "w-1.5 bg-[var(--border-soft)]"
            }`}
          />
        ))}
      </div>
      <p className="text-center text-[10px] tracking-[0.28em] uppercase text-[var(--text-secondary)] mt-3">
        {index + 1} / {paragraphs.length}
      </p>
    </div>
  );
};

export default StoryCarousel;
